module.exports = __webpack_public_path__ + "img/folder.a8ca3605.svg";